
<template>
  <page-layout
    :breadcrumbs="breadcrumbs"
    :title="$t('pages.reservas.reservasMayuscula')"
  >
    <o-main-progress v-if="loading"/>
    <ReservaListaCliente v-if="!loading" @cambiado="cambiado = $event" :tabsIn="tabsIn" :tipo="tipo" :loading="loading"/>
  </page-layout>
</template>

<script>
import ReservaListaCliente from '@/components/reservas/listas/ReservaListaCliente'
import { mapActions } from 'vuex'

export default {
  components: {
    ReservaListaCliente
  },
  data () {
    return {
      loading: true,
      tabsIn: false,
      tipo: null
    }
  },
  created () {
    this.initialize()
  },
  beforeRouteLeave (to, from, next) {
    if (this.cambiado) {
      let respuesta = confirm(this.$t('general.misc.alertPreRefresh'))
      if (respuesta) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  computed: {
    breadcrumbs () {
      if (this.esAdministrador) {
        return [
          {
            text: this.$t('pages.home'),
            exact: true,
            to: {name: 'home'}
          },
          {
            text: this.$t('pages.reservas.reservas'),
            disabled: true
          }
        ]
      } else {
        return [
          {
            text: this.$t('pages.reservas.reservas'),
            disabled: true
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions({
      comprobarReservas: 'reservas/comprobarReservas',
      loadPromociones: 'promociones/loadAll',
      addAlert: 'alerts/add'
    }),
    async initialize () {
      try {
        await Promise.all([
          this.checkReservas(),
          this.loadPromociones()
        ])
        this.loading = false
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    async checkReservas () {
      try {
        const aux = await this.comprobarReservas()
        if (aux.venta > 0 && aux.alquiler > 0) {
          this.tabsIn = true
        } else {
          if (aux.venta > 0) {
            this.tipo = 'VENTA'
          } else {
            this.tipo = 'ALQUILER'
          }
          this.tabsIn = false
        }
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reservas.vue